/* Copyright (C) Okahu Inc 2023-2024. All rights reserved.*/

// Graph configuration
export {
  NODE_STYLES,
  LINK_STYLES,
  LAYOUT_CONFIG,
  EXPANDER_STYLES,
  type NodeCategory,
} from './graph-config';

// Type export
export type { GoMake } from './templates/shared';

// Templates
export {
  registerAllTemplates,
  createNodeToolTip,
  createTurnNodeTemplate,
  createEndNodeTemplate,
  createAgentNodeTemplate,
  createToolNodeTemplate,
  createSkeletonNodeTemplate,
  startSkeletonAnimation,
  stopSkeletonAnimation,
  createTurnLoaderNodeTemplate,
  startTurnPaginationAnimation,
  stopTurnPaginationAnimation,
  createLinkTemplate,
} from './templates';

// Layout
export { CurvedMultiLinkDigraphLayout } from './layout';
